import { message } from 'antd';
import '../constants/login.js';
import '../constants/activity.js';
import { SubPackageSlugEnum } from '../constants/common.js';
import { specialRbacInnerCodeMap } from '../constants/specialInnerCode.js';
import { get } from './get.js';
import { getTransErrorMsg } from './getTransErrorMsg.js';

/* eslint-disable react-func/max-lines-per-function */
const UN_AUTHENTICATE_CODE_LIST = [401];
const specialCodeTipMap = {
    [specialRbacInnerCodeMap['rbacUnAuthenticate']]: error => {
        window.location.href = window.origin;
    },
};
const ignoreCodeList = [
    specialRbacInnerCodeMap['rbacThirdEmailNotRegister'],
    specialRbacInnerCodeMap['rbacThirdEmailHasRegister'],
    specialRbacInnerCodeMap['rbacActivationPageInvalid'],
    specialRbacInnerCodeMap['rbacThirdEmailCodeError'],
];
function rbacErrorHandler(error) {
    // Ignore error when request is canceled by user:
    const isCanceled = !(error instanceof Error) && error && typeof error.message === 'string';
    if (isCanceled)
        return;
    if (!error?.response)
        return;
    const m = get(error, 'response.data.msg');
    const msg = m || get(error, 'response.data.error', '服务器错误');
    const statusCode = get(error, 'response.status');
    const innerCode = get(error, 'response.data.code', 0);
    get(error, 'response.data.request_info.uri');
    // 判断所有需要特殊处理的错误码逻辑
    if (specialCodeTipMap[innerCode]) {
        const isResolve = specialCodeTipMap[innerCode]?.(error, msg);
        return isResolve ? Promise.resolve(get(error, 'response.data')) : Promise.reject(error);
    }
    else if (ignoreCodeList.includes(innerCode)) {
        return Promise.reject(error);
    }
    else if (UN_AUTHENTICATE_CODE_LIST.includes(Number(statusCode))) {
        // 在权限校验失败的时候默认跳转到登录路由
        window.location.href = `${window.origin}/${SubPackageSlugEnum.Center}/login`;
        return;
    }
    else {
        message.error(getTransErrorMsg(msg));
        return Promise.reject(error);
    }
}

export { rbacErrorHandler };
